import { render, staticRenderFns } from "./priority.vue?vue&type=template&id=76112096&scoped=true&"
import script from "./priority.vue?vue&type=script&lang=js&"
export * from "./priority.vue?vue&type=script&lang=js&"
import style0 from "./priority.vue?vue&type=style&index=0&id=76112096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76112096",
  null
  
)

export default component.exports